// "My Eval Said 0% (It Couldn't See)" — the measurement episode promised at the end of
// ep 43 "The Quality Layer, Shipped". Cold Compute / Neon kit. ~129s @ 30fps.
//
// CONTINUITY: ep 43 closed on "a quality layer that's live, reachable, and on by
// default, waiting to be measured" + the card "Shipped, not a victory lap. Proving it
// comes next." Ep 43's honest beat also said the eval harness that would QUANTIFY the
// work was half-built, and that the deeper retrieval work was deliberately deferred
// behind that measurement. THIS episode is that measurement finally happening — and the
// twist is that the instrument was broken FOUR separate times in a single day, and every
// broken version produced a number that looked like a legitimate product finding.
//
// GROUNDED in EAKC-MVP (measured 2026-07-19 — every on-screen number is real):
//   - The job: for each failure decide RETRIEVER-side (the answer's source was never
//     fetched) vs GENERATOR-side (source fetched, model mishandled it). That split gates
//     a big, expensive, deferred piece of work. It is exactly the gate ep 43 deferred
//     the retrieval work behind.
//   - The reading: 0% retriever-side. Read literally, retrieval is perfect and every
//     failure is the model's fault. It would have killed the retrieval work.
//   - BUG ONE (it could not see): the classifier can only prove a retriever miss when
//     the case carries a label naming the source that should have answered it. ZERO of
//     15 golden cases carried that label, so every failure fell to the conservative
//     "generator" default. 0% was never a measurement. Labelled → 50%.
//   - BUG TWO (a probe on a column that does not exist): the corpus check queried a
//     field the table never had, so it always came back empty and marked present-in-the-
//     corpus sources as "never ingested" — which are excluded from the gate maths.
//     Fixed → 66.7%.
//   - BUG THREE (the other half of the gate was hardcoded): the multi-hop metric
//     returned false on every code path. It could only ever read 0.0%, and 0.0% is
//     precisely the number the gate is written on. Made real → still 0.0%, but now it
//     MEANS something.
//   - BUG FOUR (the harness was stricter than production): the harness fetched the top 5
//     results while production gives the model 8, 15 or 20 depending on the question.
//     Correct answers sitting at ranks 6, 10 and 13 were being counted as retrieval
//     failures purely because the harness stopped at 5. Fixed → 62.5%, and passing cases
//     went 4 of 15 → 7 of 15.
//   - THE PUNCH on bug four: it changed no retrieval code at all. Production had always
//     behaved that way; the harness had simply been marking it wrong. The numbers did not
//     get better, the measurement got honest.
//   - THE VERDICT: retriever-side 62.5% clears its bar, but the multi-hop half reads 0%,
//     and that is the half the gate is written on. So the expensive work stays deferred.
//     The failures are first-hop: a multi-hop loop fixes "found A, A points to B, never
//     fetched B" and does nothing for "never found A".
//
// ON-SCREEN NUMBER ALLOWLIST (nothing else appears as a figure anywhere):
//   0%, 0 of 15, 50%, 66.7%, 0.0%, 62.5%, 4 of 15, 7 of 15, ranks 6/10/13, top 5, 8/15/20.
// NO latency, NO cost, NO "X% better", NO faithfulness/hallucination figures.
// NO migration names or numbers. No em-dashes in narration or on-screen copy.
// This is a story about measurement honesty, NOT a quality win.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames @30fps; contiguous.
export const SCENE = {
  hook: { start: 0, duration: 300 }, //          0:00–0:10  ep43 promised proof — this is that measurement
  split: { start: 300, duration: 315 }, //       0:10–0:20  retriever's fault vs generator's fault
  zero: { start: 615, duration: 285 }, //        0:20–0:30  the gate said 0% retriever-side
  bug1: { start: 900, duration: 420 }, //        0:30–0:44  bug one: 0 of 15 labeled → 50%
  bug2: { start: 1320, duration: 390 }, //       0:44–0:57  bug two: probe on a missing column → 66.7%
  bug3: { start: 1710, duration: 405 }, //       0:57–1:10  bug three: multi-hop hardcoded false → real 0.0%
  bug4: { start: 2115, duration: 465 }, //       1:10–1:26  bug four: harness stopped at top 5
  punch: { start: 2580, duration: 360 }, //      1:26–1:38  62.5% · 4 of 15 → 7 of 15 · no retrieval code changed
  verdict: { start: 2940, duration: 435 }, //    1:38–1:52  clears its bar, but the multi-hop half is the gate
  lesson: { start: 3375, duration: 300 }, //     1:52–2:02  the instrument moved, not the product
  outro: { start: 3675, duration: 195 }, //      2:02–2:09
} as const;

export const TOTAL_DURATION = 3870; // 129s — verified contiguous sum below
// hook300 + split315 + zero285 + bug1_420 + bug2_390 + bug3_405 + bug4_465
//   + punch360 + verdict435 + lesson300 + outro195 = 3870 (129s)

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
